import { graphql } from "gatsby"
import React from "react"

import LargeFeature from "../feature/LargeFeature"
import SmallFeature from "../feature/SmallFeature"
import SmallFeature2 from "../feature/SmallFeature2"
import LargeProduct from "../product/LargeProduct"
import SmallStaticImage from "../staticImage/SmallStaticImage"
import SmallStaticImage2 from "../staticImage/SmallStaticImage2"
import LargeStaticImage from "../staticImage/LargeStaticImage"
import SmallVideo from "../video/SmallVideo"
import SmallVideo2 from "../video/SmallVideo2"
import LargeVideo from "../video/LargeVideo"

export interface IProductFooter {
  headline: string
  link: {
    target: string
    title: string
    url: string
  }
}

export interface IProductProps {
  backgroundImage: any
  buttonLabel: string
  fieldGroupName: string
  button: any
  icon: any
  footer?: IProductFooter
  product: IProduct
}

export interface IProduct {
  link: string
  acfProduct: any
  title: string
  product: {
    description: string
    variants: {
      compareAtPrice: string
      price: string
    }
  }
}

export interface IStaticImageProps {
  backgroundImage: any
  footer?: IProductFooter
}

export interface IFeatureProps {
  fieldGroupName: string
  backgroundImage: any
  button: {
    target: string
    title: string
    url: string
  }
  description: string

  headline: string
  icon: any
  subHeadline: string
  footer?: IProductFooter
}

export interface IVideoProps {
  fieldGroupName: string
  playIcon: IImageData
  videoEmbedUrl: string
  footer?: IProductFooter
  videoThumbNail: IImageData
}

interface IOneLargeTwoSmallProps {
  largeTileBlocks:
    | IProductProps
    | IStaticImageProps
    | IVideoProps
    | IFeatureProps[]
  smallTileSmallblocks: IStaticImageProps | IVideoProps | IFeatureProps[]
  smallTile2Smallblocks: IStaticImageProps | IVideoProps | IFeatureProps[]
  reverseOrder: boolean
}

const OneLargeTwoSmall: React.FC<IOneLargeTwoSmallProps> = ({
  largeTileBlocks,
  smallTileSmallblocks,
  smallTile2Smallblocks,
  reverseOrder,
}) => {
  const largePromoType =
    largeTileBlocks[0].fieldGroupName &&
    largeTileBlocks[0].fieldGroupName.split("_").slice(-1)[0]
  const smallPromoType =
    smallTileSmallblocks[0]?.fieldGroupName &&
    smallTileSmallblocks[0]?.fieldGroupName.split("_").slice(-1)[0]
  const smallPromoType2 =
    smallTile2Smallblocks[0]?.fieldGroupName &&
    smallTile2Smallblocks[0]?.fieldGroupName.split("_").slice(-1)[0]

  return (
    <div
      className={
        !reverseOrder
          ? "mt-[10px] flex flex-col flex-wrap justify-center md:flex-row md:flex-nowrap"
          : "mt-[10px] flex flex-col flex-wrap justify-center md:flex-row-reverse md:flex-nowrap"
      }
    >
      <div className="mt-[15px] w-full text-right md:mx-[10px] md:w-[740px]">
        {largePromoType === "Product" && (
          <LargeProduct {...largeTileBlocks[0]} />
        )}

        {largePromoType === "StaticImage" && largeTileBlocks && (
          <LargeStaticImage {...largeTileBlocks[0]} />
        )}
        {largePromoType === "Video" && largeTileBlocks && (
          <LargeVideo {...largeTileBlocks[0]} />
        )}
        {largePromoType === "Feature" && (
          <LargeFeature {...largeTileBlocks[0]} />
        )}
      </div>
      <div className="flex w-full flex-col md:mx-[10px] md:w-[300px] md:px-0 lg:w-[499px] ">
        {smallPromoType === "StaticImage" && smallTileSmallblocks && (
          <div className="mt-[15px]">
            <SmallStaticImage {...smallTileSmallblocks[0]} />
          </div>
        )}
        {smallPromoType === "Feature" && smallTileSmallblocks && (
          <div className="mt-[15px]">
            <SmallFeature {...smallTileSmallblocks[0]} />
          </div>
        )}

        {smallPromoType === "Video" && smallTileSmallblocks && (
          <div className="mt-[15px]">
            <SmallVideo {...smallTileSmallblocks[0]} />
          </div>
        )}

        {smallPromoType2 === "StaticImage" && smallTile2Smallblocks && (
          <div className="mt-[19px]">
            <SmallStaticImage2 {...smallTile2Smallblocks[0]} />
          </div>
        )}

        {smallPromoType2 === "Feature" && smallTile2Smallblocks && (
          <div className="mt-[19px]">
            <SmallFeature2 {...smallTile2Smallblocks[0]} />
          </div>
        )}

        {smallPromoType2 === "Video" && smallTile2Smallblocks && (
          <div className="mt-[19px]">
            <SmallVideo2 {...smallTile2Smallblocks[0]} />
          </div>
        )}
      </div>
    </div>
  )
}

export default OneLargeTwoSmall

export const fragment = graphql`
  fragment PromoModule on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_Promos {
      promos {
        ...LargeFeature
        ...SmallFeature
        ...SmallFeature2
        ...LargeProduct
        ...LargeStaticImage
        ...SmallStaticImage
        ...SmallStaticImage2
        ...LargeVideo
        ...SmallVideo
        ...SmallVideo2
      }
    }
  }
`
